// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintSuggestionsStep-cls1_dnw","cls2":"PreprintSuggestionsStep-cls2_ZVD PreprintSuggestionsStep-cls1_dnw"};